import React from "react";

import data from "currency-codes/data";

import {
	TextInput,
	SelectInput,
	CheckboxInput,
} from "../../../../forms/components";

class CreateMerchantDetails extends React.Component {
	constructor(props) {
		super(props);

		const priorityCode = ["SGD", "MYR", "USD"];
		const codes = [
			...data.filter((i) => priorityCode.includes(i.code)),
			...data.filter((i) => !priorityCode.includes(i.code)),
		];

		this.state = {
			currency: [
				...codes.map((d) => {
					return { name: d.code, value: d.number };
				}),
			],
		};
	}

	handleResellerChange = (value) => {
		const target = this.props.resellers.find(
			(reseller) => reseller._id === value
		);
		// this.props.retrieveBaseRate(target?._id);
		this.props.updateReseller(target?._id);
	};

	render() {
		return (
			<div className="uk-margin-medium-bottom">
				<h4>
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-info-circle; ratio: 0.9"
						/>
						Details
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>
				<div className="uk-padding-small uk-padding-remove-vertical">
					<SelectInput
						label="Reseller"
						id="reseller"
						name="reseller"
						initialEmpty={true}
						data={this.props.resellers.map((item) => {
							return { value: item._id, name: item.name };
						})}
						handleChange={this.handleResellerChange}
					/>
					<TextInput
						label="Name"
						id="name"
						name="name"
						type="text"
						placeholder=""
					/>
					<div className="uk-child-width-1-2 uk-grid">
						<TextInput
							noMargin={true}
							label="Receipt Name"
							id="receiptName"
							name="receiptName"
							type="text"
							placeholder=""
						/>
						<TextInput
							noMargin={true}
							label="Statement Name"
							id="statementName"
							name="statementName"
							type="text"
							placeholder=""
							maxLength="20"
						/>
					</div>
					<SelectInput
						label="Default Currency"
						data={this.state.currency}
						id="defaultCurrency"
						name="defaultCurrency"
						initialEmpty={true}
					/>
					<CheckboxInput
						name="requireSignature"
						id="requireSignature"
						label="Require Customer Signature"
					/>
				</div>
			</div>
		);
	}
}

export default CreateMerchantDetails;
